/**** cat.DevCamera */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  apiType: apiTypes.REPORT_API,
  table: 'camera_types',
  title: 'Типы видеокамер',
  elemsOnPage: 100,
  fields: [
    {
      name: 'ip',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'index',
      title: 'Порядковый номер камеры',
      type: 'number',
      width: '120px',
      required: true,
    },
    {
      name: 'title',
      title: 'Название ',
      type: 'text',
      required: true,
    },
    {
      name:    'security',
      title:   'Выбор видеокамеры для получения фото/видеоматериалов о событиях СМСВ',
      type:    'boolean',
      unique:  true,
      width:   '300px',
    },
  ],
  newTemplate: {
    ip: null,
    index: null,
    title: null,
    security: false,
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'index',
    direction: 'asc',
  },
  import: {
    header: [
      {
        title: 'camera_id',
        field: 'ip',
      },
      {
        title: 'index',
        field: 'index',
      },
      {
        title: 'title',
        field: 'title',
      },
      {
        title: 'security',
        field: 'security',
      },
    ],
    example: `1;1;Камера заднего вида;false`,
  },
  export: {
    fields: [
      {
        name: 'index',
        title: 'Порядковый номер камеры',
      },
      {
        name: 'title',
        title: 'Название ',
      },
      {
        name: 'security',
        title: 'Выбор видеокамеры для получения фото/видеоматериалов о событиях СМСВ',
      },
    ],
  },
};

export default config;
